export default "__VITE_ASSET__DcvSMz1N__"